import React, { useRef, useState } from 'react';
import { Text, useBreakpoint, Container, Stack, Accordion } from 'basis';
import { useStoreValue } from 'store';
import styled from '@emotion/styled';
import { LandingContentItem, OverviewBox } from './LandingPageGemNz.styles';
import ProfileIcon from '../../images/icons/au-nz/profile-single.svg';
import HomeIcon from '../../images/icons/au-nz/home.svg';
import WalletIcon from '../../images/icons/au-nz/finance-wallet.svg';
import MoneyIcon from '../../images/icons/au-nz/finance-pay-manual.svg';
import FinanceCardIcon from '../../images/icons/au-nz/finance-card.svg';
import IdentityIcon from '../../images/icons/au-nz/identity.svg';
import StopwatchIcon from '../../images/icons/au-nz/stopwatch.svg';

export const isValidStoreOffer = storeState => storeState?.offer?.status === 'VALID';
export const AccordionWhenXS = ({ children, pinkStyling }) => {
  const breakpoint = useBreakpoint();
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const [storeState] = useStoreValue();
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  // default: 0-374px, xs: 375px-575px,
  if (breakpoint !== 'default' && breakpoint !== 'xs') {
    return children;
  }
  return (
    <Accordion
      isOpen={isOpen}
      pinkStyling={pinkStyling}
      isValidStoreOffer={isValidStoreOffer(storeState)}
      itemHeaderAs="subtitle2"
    >
      <Accordion.Item>
        <Accordion.Item.Header onClick={toggleAccordion} pinkStyling={pinkStyling}>
          {pinkStyling && isValidStoreOffer(storeState) ? storeState.offer.title : 'Things to know before you start'}
        </Accordion.Item.Header>
        <Accordion.Item.Content ref={contentRef} pinkStyling={pinkStyling}>
          {children}
        </Accordion.Item.Content>
      </Accordion.Item>
    </Accordion>
  );
};

export const ApplicationOverviewGemVisaNZ = ({ pinkStyling }) => {
  const items = [
    {
      title: 'Who can apply?',
      body: (
        <>
          <LandingContentItem>
            <img src={ProfileIcon} alt="profile-icon" />
            <Text as="p">You must be aged 18 or older</Text>
          </LandingContentItem>
          <LandingContentItem>
            <img src={HomeIcon} alt="house-icon" />
            <Text>Be a citizen or reside in New Zealand (for at least the next 12 months)</Text>
          </LandingContentItem>
          <LandingContentItem>
            <Text as="p">To be eligible you must:</Text>
          </LandingContentItem>
          <LandingContentItem>
            <img src={MoneyIcon} alt="money-icon" />
            <Text>Have an income of at least $20,000 gross per year, from employment or investments</Text>
          </LandingContentItem>
          <LandingContentItem>
            <img src={FinanceCardIcon} alt="finance-card-icon" />
            <Text>Be able to demonstrate a good credit history for the last 5 years</Text>
          </LandingContentItem>
        </>
      ),
    },
    {
      title: "What you'll need",
      body: (
        <>
          <LandingContentItem>
            <img src={MoneyIcon} alt="money-icon" />
            <Text>Income, debts and expenses information</Text>
          </LandingContentItem>
          <LandingContentItem>
            <img src={IdentityIcon} alt="id-icon" />
            <Text as="p">
              Proof of ID (New Zealand Driver Licence, New Zealand Passport or International Passport) if you consent to
              using your ID documents to verify your identity
            </Text>
          </LandingContentItem>
          <LandingContentItem>
            <img src={WalletIcon} alt="wallet-icon" />
            <Text as="p">Proof of income (such as payslips, bank statements, tax statements)</Text>
          </LandingContentItem>
        </>
      ),
    },
    {
      title: 'How long will it take?',
      body: (
        <>
          <LandingContentItem>
            <img src={StopwatchIcon} alt="money-icon" />
            <Text>
              You will need 10-15 minutes to complete the application
              <br />
              (If we need additional information from you, we will contact you within 2 business days.)
            </Text>
          </LandingContentItem>
        </>
      ),
    },
  ];

  return (
    <AccordionWhenXS>
      <Stack gap="2">
        <OverviewBox>
          {items.map((item, index) => {
            return (
              <Container margin="0 0 6 0" key={`overview-item-${index}`}>
                <Container margin="0 0 4 0">
                  <Text textStyle="heading5" as="h4">
                    {item.title}
                  </Text>
                </Container>
                {item.body}
              </Container>
            );
          })}
        </OverviewBox>
      </Stack>
    </AccordionWhenXS>
  );
};
